<div class="wrap">
    <div class="presentation" data-aos="fade-down" data-aos-duration="1500">
        <h2>
            Our Worshops
        </h2>
        <p>
         The technical axis represents one of the most important axes of NRW, it includes a variety of workshops, related to the fields of IOT, robotics and embedded systems, its main goal is to get familiar with these domains, and to acquire some technical and soft skills, that can help the 
    The technical axis represents one of the most important axes of NRW, it includes a variety of workshops, related to the fields of IOT, robotics and embedded systems, its main goal is to get familiar with these domains, and to acquire some technical and soft skills, that can help the participants develop their professional life.
    
        </p>
    </div>
      <section class="timeline">
    
        <div class="container">
            <div class="timeline-item">         
                <div class="timeline-content timeline-card " data-aos="fade-right" data-aos-duration="1500">
                  <div class="header"> 
                    <img src="../../../assets/background/Worshops/cover_stm32.jpg" alt="">
                  </div>
                  <div class="date">Workshop 1</div>
             <div class="content">
               <div class="row">
               <p >STM 32 IOT application developpement</p>
               </div>
             </div>
                </div>
              </div>  

              <div class="timeline-item">
                <div class="timeline-content timeline-card " data-aos="fade-left" data-aos-duration="1500">
                  <div class="header"> 
                    <img src="../../../assets/background/Worshops/pi.jpg" alt="">
                  </div>
                  <div class="date">Workshop 2</div>
                  <div class="content">
                    <div class="row"> <p>Raspberry Pi application developpement <br></p>
                    </div>
                  </div>
                </div>
              </div> 
              <div class="timeline-item">
                <div class="timeline-content timeline-card " data-aos="fade-right" data-aos-duration="1500">
                  <div class="header"> 
                    <img src="../../../assets/background/Worshops/linux.jpg" alt="">
                  </div>
                  <div class="date">Workshop 3</div>
                  <div class="content">
                    <div class="row">
                      <p >Embedded Linux
                        </p>
                    </div>
                  </div>
                </div>
              </div>  
              <div class="timeline-item">
                <div class="timeline-content timeline-card " data-aos="fade-left" data-aos-duration="1500">
                  <div class="header"> 
                    <img src="../../../assets/background/Worshops/ai.jpg" alt="">
                  </div>
                  <div class="date">Workshop 4</div>
               <div class="content">
               <div class="row"> <p >Embedded Artificial Intelligence</p>
               </div>
             </div>
                </div>
              </div>  
              <div class="timeline-item">
                <div class="timeline-content timeline-card " data-aos="fade-right" data-aos-duration="1500">
                  <div class="header"> 
                    <img src="../../../assets/background/Worshops/robot.jpg" alt="">
                  </div>
                  <div class="date">Workshop 5</div>
               <div class="content">
               <div class="row"> <p >Initiation to Robotics</p>
               </div>
             </div>
              </div>
              </div>

        </div>
      </section>
      <ngb-carousel #carousel [interval]="2000" >
        <ng-template ngbSlide *ngFor="let img of images">
            <div class="picsum-img-wrapper">
              <img id="workshop" [src]="img" >
            </div>
        </ng-template>
      </ngb-carousel>

</div>